import type { HELP_STATE_ACTIONS, HELP_STATE_TYPES } from '../enums';
import type { HelpStateItem } from '../interfaces';

function isSameHelpStateItem(first: HelpStateItem, second: HelpStateItem) {
  return first.type === second.type && first.key === second.key && first.action === second.action;
}

function findHelpStateItem(
  helpState: HelpStateItem[],
  type: HELP_STATE_TYPES,
  key: string,
  action: HELP_STATE_ACTIONS
) {
  return helpState.find((item) => isSameHelpStateItem(item, { action, key, type }));
}

function hasHelpState(helpState: HelpStateItem[], type: HELP_STATE_TYPES, key: string, action: HELP_STATE_ACTIONS) {
  return !!findHelpStateItem(helpState, type, key, action);
}

function replaceOrAppendHelpStateItem(helpState: HelpStateItem[], newItem: HelpStateItem) {
  return [...helpState.filter((item) => !isSameHelpStateItem(item, newItem)), newItem];
}

function removeHelpStateItem(helpState: HelpStateItem[], removedItem: HelpStateItem) {
  return helpState.filter((item) => !isSameHelpStateItem(item, removedItem));
}

export { findHelpStateItem, hasHelpState, removeHelpStateItem, replaceOrAppendHelpStateItem };
